import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "nav-tags-container" }
const _hoisted_2 = { class: "nav-tags-content" }

import { onMounted, ref, nextTick, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import { useTagsStoreHook } from '@/store/modules/tags';
import Tag from './tag.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const staticTagList = useTagsStoreHook().staticTagList;
const tagList = useTagsStoreHook().tagList;

const allTags = computed(() => {
  return [...staticTagList, ...tagList];
});
const toHome = (path: string) => {
  useTagsStoreHook().setActivedTagPath(path);
  router.push(path);
};
const onClose = (tag: any, index: number, isCurrent: boolean) => {
  let nextPath = '';
  let nextRoute = null;
  if (isCurrent) {
    if (index === 0) {
      nextRoute = staticTagList[staticTagList.length - 1];
      nextPath = nextRoute.path;
    } else {
      nextRoute = tagList[index - 1];
      nextPath = nextRoute.path;
    }
  }

  useTagsStoreHook().deleteTag(index, tag, nextPath);
};
const route = useRoute();

const tagContent = ref();

const tagMinX = ref(0);
const tagMaxX = ref(0);
const tagTransformX = ref(0);
const setTagMinX = () => {
  if (!tagContent.value) return;
  tagMinX.value = tagContent.value.offsetWidth - tagContent.value.scrollWidth;
};
onMounted(() => {
  setTagMinX();
});
const reset = () => {
  nextTick(() => {
    setTagMinX();
    setTransform();
  });
};
watch(() => route.path, reset);
watch(() => tagList.length, reset);

const toPrev = () => {
  const currentIndex = getCurrentIndex();

  if (currentIndex <= 0) {
    tagTransformX.value = 0;
    return;
  }

  const currentTagNode = getCurrentTagNode(currentIndex - 1);
  let targetDistance = tagTransformX.value + currentTagNode.offsetWidth;
  if (targetDistance > 0) {
    targetDistance = 0;
  }
  tagTransformX.value = targetDistance;
};
const toNext = () => {
  const currentIndex = getCurrentIndex();

  if (currentIndex >= allTags.value.length - 1) {
    tagTransformX.value = tagMinX.value;
    return;
  }
  const currentTagNode = getCurrentTagNode(currentIndex + 1);
  let targetDistance = tagTransformX.value - currentTagNode.offsetWidth;
  if (targetDistance < tagMinX.value) {
    targetDistance = tagMinX.value;
  }
  tagTransformX.value = targetDistance;
};
function setTransform() {
  if (tagMinX.value >= 0) {
    tagTransformX.value = 0;
    return;
  }
  const currentIndex = getCurrentIndex();
  if (currentIndex < 0) return;
  const currentTagNode = getCurrentTagNode(currentIndex);
  const positionX = getInCenterPositionX(currentTagNode);

  tagTransformX.value = positionX;
}

function getCurrentIndex() {
  const currentPath = route.path;
  const currentIndex = allTags.value.findIndex(
    (tag) => tag.path === currentPath
  );
  return currentIndex;
}

function getCurrentTagNode(index: number): HTMLSpanElement {
  const children = [...tagContent.value.children];
  return children[index];
}
function getInCenterPositionX(currentTagNode: HTMLSpanElement): number {
  const { offsetLeft, offsetWidth } = currentTagNode;
  const contentWidth = tagContent.value.offsetWidth;
  let positionX = 0;

  positionX = offsetLeft + offsetWidth / 2 - contentWidth / 2;
  console.log('positionX', positionX);
  if (-positionX > 0) {
    return 0;
  }
  const maxDistance = Math.abs(tagMinX.value);
  if (Math.abs(positionX) > maxDistance) {
    return -maxDistance;
  }
  return -positionX;
}

return (_ctx: any,_cache: any) => {
  const _component_arrow_left = _resolveComponent("arrow-left")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_arrow_right = _resolveComponent("arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "nav-tag-to-left",
      onClick: toPrev
    }, [
      _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          _createVNode(_component_arrow_left)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "tagContent",
        ref: tagContent,
        style: _normalizeStyle({
          transform: `translateX(${tagTransformX.value}px)`,
          transition: 'transform .25s',
        })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(staticTagList), (tag) => {
          return (_openBlock(), _createBlock(Tag, {
            key: tag.name,
            actived: _unref(useTagsStoreHook)().activedTagPath === tag.path,
            onClick: ($event: any) => (toHome(tag.path))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(tag.meta.title)), 1)
            ]),
            _: 2
          }, 1032, ["actived", "onClick"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagList), (tag, index) => {
          return (_openBlock(), _createBlock(Tag, {
            closable: "",
            key: tag.name,
            actived: _unref(useTagsStoreHook)().activedTagPath === tag.path,
            onClick: ($event: any) => (toHome(tag.path)),
            onClose: ($event: any) => (onClose(tag, index, _unref(route).path === tag.path))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tag.meta.i18n ? _ctx.$t(tag.meta.title) : tag.meta.title), 1)
            ]),
            _: 2
          }, 1032, ["actived", "onClick", "onClose"]))
        }), 128))
      ], 4)
    ]),
    _createElementVNode("span", {
      class: "nav-tag-to-right",
      onClick: toNext
    }, [
      _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          _createVNode(_component_arrow_right)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})